import * as React from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import DialogTitle from "@mui/material/DialogTitle";
import { DialogContent } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import TextField from "@mui/material/TextField";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { useTranslation } from 'react-i18next';

import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import AppContext from "../../utils/context";

export default function ProjectDialog(props) {
  const appContext = React.useContext(AppContext);
  const { t } = useTranslation(); // Utiliser la fonction de traduction
  const { events, database } = appContext;
  const [open, setOpen] = React.useState(false);
  const [search, setSearch] = React.useState("");
  const [items, setItems] = React.useState([]);
  const [workspaceScope, setWorkspaceScope] = React.useState(null);
  const [callbacks, setCallbacks] = React.useState({});
  const [componentScope, setComponentScope] = React.useState(null);
  const [searchResults, setSearchResults] = React.useState([]);

  React.useEffect(() => {
    const off = events.on("search", (e) => {
      if(!open)
        handleSearch(e);
    });

    return () => {
      off();
    };
  }, []);

  const handleClose = () => {
    setOpen(false);
    setCallbacks({});
    setWorkspaceScope(null);
    setComponentScope(null);
    setItems([]);
    setSearch("");
  };

  const handleSearch = async (e) => {
    setCallbacks(() => e.callbacks);
    setOpen(true);
    if (e?.workspaceScope) setWorkspaceScope(e.workspaceScope);
    if (e?.componentScope) setComponentScope(e.componentScope);
  };

  React.useEffect(() => {
    const searchItems = async () => {
      try {
        const { data, error } = await database
        .rpc("search", {
          q: search,
        })

        

      if (error) throw error;
      setSearchResults(data);
        setItems(data.sort((a, b) => a.label.localeCompare(b.label)));
      } catch (error) {
        events.dispatch("alert-message", {
          data: { message: t('search.error'), severity: "error" },
        });
      }
    };

    if (search.length >= 2) {
      searchItems();
    } else {
      setItems([]);
    }
  }, [search]);


  const selectItem = (item) => {
    const clbk = callbacks[item.type.toString().toLowerCase()];
    if (clbk) {
      clbk(item);
      setOpen(false);
      handleClose()
    }
  };

  const columns = [
    {
      field: "name",
      headerName: t('commons.name'),
      width: 440,
      renderCell: (params) => (
        <div style={{ display: "flex", flexDirection: "column", paddingTop: "1em", paddingBottom: "1em" }}>
          {params?.row?.type == 'workspace' && <div>
            <strong>{params.row.label}</strong>
            <br />
            <small>{params.row.type}</small>
          </div>}
          {params?.row?.type == 'project' && <div>
            <strong>{params.row.label}</strong>
            <br />
            {params?.row?.project_template_name && <small>{t(params.row.project_template_name)}</small>}
            <br />
            <small>{t('commons.workspace')} {params.row.workspace_name}</small>
          </div>}
          {params?.row?.type == 'instance' && <div>
            <strong>{params.row.label}</strong>
            <br />
            {params?.row?.component_name && <small>{t(params.row.component_name)}</small>}
            <br />
            <small>{t('commons.workspace')} {params.row.workspace_name}</small>
          </div>}
        </div>
      ),
    },
    {
      field: "actions",
      headerName: "",
      width: 50,
      type: "actions",
      getActions: (params) => [
        <GridActionsCellItem
          icon={<KeyboardArrowRightIcon />}
          label="View"
          onClick={() => selectItem(params.row)}
        />,
      ],
    },
  ];

  return (
    <React.Fragment>
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle sx={{ paddingTop: "1em" }}>
          <TextField
            placeholder={t('commons.search')}
            fullWidth
            size="small"
            InputProps={{
              startAdornment: <SearchIcon />,
            }}
            value={search}
            variant="standard"
            onChange={(event) => setSearch(event.target.value)}
            autoFocus
          />
        </DialogTitle>
        <DialogContent>
          <Box sx={{ width: "500px" }}>
            {items.length > 0 && (
              <Box sx={{ height: "500px", display: "flex", flexDirection: "column" }}>
                <DataGrid
                  rows={items}
                  columns={columns}
                  getRowHeight={() => "auto"}
                  disableColumnResize={true}
                  style={{ border: "none", flexGrow: 1 }}
                  disableColumnMenu
                  columnHeaderHeight={0}
                  getRowId={(row) => {
                    if (row.type == "workspace") return row.workspace_id;
                    if (row.type == "project") return row.project_id;
                    if (row.type == "instance") return row.instance_id;
                  }}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 50,
                      },
                    },
                  }}
                  pageSizeOptions={[50]}
                />
              </Box>
            )}
          </Box>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
